import { lockScroll } from '../utility';

const { lock, unlock } = lockScroll();

class HamburgerMenu {
  constructor(triggerButton, menu, menuContent) {
    this.triggerButton = triggerButton;
    this.menu = menu;
    this.menuContent = menuContent;
    this.isExpanded = false;
    this.hideMenuWithClickBgBindThis = () => {};
  }

  init() {
    this.triggerButton.addEventListener('click', () => this.handleClickTrigger());
  }

  showMenu() {
    this.isExpanded = true;
    this.triggerButton.setAttribute('aria-expanded', 'true');
    this.triggerButton.setAttribute('aria-label', 'メニューを非表示にする');
    this.menu.setAttribute('aria-hidden', 'false');

    this.hideMenuWithClickBgBindThis = this.hideMenuWithClickBg.bind(this);
    window.addEventListener('click', this.hideMenuWithClickBgBindThis);
  }

  hideMenu() {
    this.isExpanded = false;
    this.triggerButton.setAttribute('aria-expanded', 'false');
    this.triggerButton.setAttribute('aria-label', 'メニューを表示する');
    this.menu.setAttribute('aria-hidden', 'true');

    window.removeEventListener('click', this.hideMenuWithClickBgBindThis);
  }

  hideMenuWithClickBg(e) {
    const triggerButtonClass = `.${this.triggerButton.className.split(' ').join('.')}`;
    const menuContentClass = `.${this.menuContent.className.split(' ').join('.')}`;
    if (!e.target.closest(triggerButtonClass) && !e.target.closest(menuContentClass)) {
      this.hideMenu();
      unlock();
    }
  }

  handleClickTrigger() {
    if (this.isExpanded) {
      this.hideMenu();
      unlock();
    } else {
      this.showMenu();
      lock();
    }
  }
}

export const hamburgerMenu = () => {
  const triggerButton = document.getElementById('js-hamburger');
  const menu = document.getElementById('js-hamburger-menu');
  const menuContent = document.getElementById('js-hamburger-menu-content');
  if (!triggerButton || !menu || !menuContent) return;
  const hamburgerInstance = new HamburgerMenu(triggerButton, menu, menuContent);
  hamburgerInstance.init();
};
